
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { routerNames } from "@/common/js/const";
import Box from 'vux/src/components/box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import conf from "./../../config/base.js";
import { getWxizedUrl } from "@/common/js/common";

export default {
name: routerNames.OrderInvoiceFollow,
components: {
Box,
Group,
Cell,
CellBox,
XHeader
},
data() {
return {
logoSrc: "",
qrMsg: "",
merchant: "",
cpy: "",
queryJson: "",
sub:"",//子品牌，部分商户需要根据子品牌区分不同公众号开票
};
},
created() {},
activated() {
var $self = this;
console.log($self.$route.query);
$self.queryJson = $self.$route.query;
$self.merchant = $self.$route.query.br;
$self.sub = $self.$route.query.sub;
$self.cpy = $self.$route.query.cpy;
$self.logoSrc = "/xforce/static/merch/" + $self.merchant + "/logo.jpg";

$self.subscribeWx();
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
mounted() {},
methods: {
subscribeWx() {
var $self = this;
$self.$webapi.subscribeWx($self.merchant).then(res1 => {
$self.$clog("subscribeWx response");
$self.$clog(res1.data);

if (res1.data.status == 0) {
$self.$router.replace({
path: "/orderinvoice/follownon",
query: $self.queryJson
});
} else if (res1.data.status == 1) {
$self.initPage();
}
});
},

initPage() {
var $self = this;
var ua = window.navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == "micromessenger") {
const params = {
dataMap: JSON.stringify({
data: $self.cpy,
businessType: "pos",
type: "0"
})
};
$self.$webapi.redisInOut(params).then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
const groupFlag = $self.sub && $self.sub!=='' ? `${$self.merchant}-${$self.sub}`:$self.merchant;
$self.$webapi.gWx3rdAppId(groupFlag).then(appidRes => {
$self.$clog(appidRes.data);
if (appidRes.data.status == 1) {

window.location.href = getWxizedUrl(
groupFlag,
"/xforce/#/orderInvoice/followQrcode?",
"_" + $self.merchant + "_" + res.data.result,
appidRes.data.result
);
} else {
$self.$vux.alert.show({
title: "提示",
content: appidRes.data.msg,
onShow() {},
onHide() {}
});
}
});
}
});
} else if (ua.match(/Alipay/i) == "alipay") {
var dataJson = {
br: $self.merchant,
cpy: $self.cpy,
type: "ali"
};
$self.$webapi.orderQrcode(dataJson).then(res => {
if (res.data.status == 1) {
setTimeout((window.location.href = res.data.url), 300);
} else {
$self.qrMsg = res.data.msg;
}
});
}
}
}
};
